import { useQuery, gql, QueryHookOptions } from '@apollo/client'

import { Discount } from '../types'

interface Data {
  discounts: Discount[]
}

interface Variables {
  filter: string
}

const query = gql`
  query FetchDiscounts($filter: Filter) {
    discounts(filter: $filter) {
      store {
        id
      }
      organization {
        id
      }
      percent
    }
  }
`
const useFetchDiscounts = (options?: QueryHookOptions<Data, Variables>) =>
  useQuery<Data, Variables>(query, { ...options, fetchPolicy: 'no-cache' })

export default useFetchDiscounts
